import type {

  CandidateStatus,

  TeamCandidate,

  TeamFormationSummary,

  TeamFormationWorkspace,

  TeamLeadershipAssignment,

} from "./teamFormationTypes";



const PRIORITY_LABELS: Record<number, string> = {

  1: "Most Recent Host-Parish Retreat",

  2: "Other Host-Parish First-Time Candidates",

  3: "Experienced Host-Parish Couples",

  4: "Deanery First-Time Candidates",

  5: "Experienced Deanery Couples",

  6: "Broader LOVESTRONG Community",

};



function computePriority(input: {

  geographicScope: string;

  firstTimeTeamCandidate: boolean;

  wasMostRecentHostParishRetreat: boolean;

}) {

  if (

    input.geographicScope === "HOST_PARISH" &&

    input.firstTimeTeamCandidate &&

    input.wasMostRecentHostParishRetreat

  ) {

    return 1;

  }

  if (input.geographicScope === "HOST_PARISH" && input.firstTimeTeamCandidate) {

    return 2;

  }

  if (input.geographicScope === "HOST_PARISH") return 3;

  if (input.geographicScope === "DEANERY" && input.firstTimeTeamCandidate) {

    return 4;

  }

  if (input.geographicScope === "DEANERY") return 5;

  return 6;

}



export const MOCK_SPIRITUAL_MENTOR_OPTIONS = [

  { principalId: "couple-yanez", displayName: "Jesse & Marta Yanez" },

  { principalId: "couple-ramirez", displayName: "Jose & Adriana Ramirez" },

];



export const MOCK_SPIRITUAL_DIRECTOR_OPTIONS = [

  { principalId: "clergy-velazquez", displayName: "Fr. Carlos Velazquez" },

  { principalId: "clergy-martinez", displayName: "Deacon James Martinez" },

];



const RAW_CANDIDATES = [

  {

    coupleId: "candidate-reyes",

    displayName: "Samuel & Lucia Reyes",

    parishName: "St. Monica",

    language: "Spanish",

    attendedRetreat: {

      parishName: "St. Monica",

      weekend: "April 14–16, 2023",

      wasMostRecentHostParishRetreat: true,

    },

    teamHistory: [] as string[],

    priorRoles: [] as string[],

    geographicScope: "HOST_PARISH",

    commitments: [],

  },

  {

    coupleId: "candidate-vega",

    displayName: "Arturo & Isabel Vega",

    parishName: "St. Francis of Assisi",

    language: "English",

    attendedRetreat: {

      parishName: "St. Francis of Assisi",

      weekend: "March 8–10, 2024",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: [],

    priorRoles: [],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-alvarez",

    displayName: "Daniel & Sofia Alvarez",

    parishName: "Sacred Heart",

    language: "Spanish",

    attendedRetreat: {

      parishName: "Sacred Heart",

      weekend: "October 4–6, 2024",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: [],

    priorRoles: [],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-ramirez",

    displayName: "Jose & Adriana Ramirez",

    parishName: "Sacred Heart",

    language: "English",

    attendedRetreat: {

      parishName: "Sacred Heart",

      weekend: "September 15–17, 2023",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: [],

    priorRoles: [],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-ortiz",

    displayName: "Marco & Elena Ortiz",

    parishName: "Sacred Heart",

    language: "Spanish",

    attendedRetreat: {

      parishName: "Sacred Heart",

      weekend: "October 4–6, 2024",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: [],

    priorRoles: [],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-salinas",

    displayName: "Hector & Monica Salinas",

    parishName: "Sacred Heart",

    language: "Spanish",

    attendedRetreat: {

      parishName: "Sacred Heart",

      weekend: "October 1–3, 2021",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: ["Tables - 2022"],

    priorRoles: ["Tables"],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-castillo",

    displayName: "Ruben & Leticia Castillo",

    parishName: "Sacred Heart",

    language: "English",

    attendedRetreat: {

      parishName: "Sacred Heart",

      weekend: "September 9–11, 2022",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: ["Kitchen - 2023", "Facilities - 2024"],

    priorRoles: ["Kitchen", "Tables"],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [],

  },

  {

    coupleId: "candidate-moreno",

    displayName: "Gabriel & Teresa Moreno",

    parishName: "St. Mark the Evangelist",

    language: "English",

    attendedRetreat: {

      parishName: "St. Mark the Evangelist",

      weekend: "March 10–12, 2023",

      wasMostRecentHostParishRetreat: false,

    },

    teamHistory: ["Music - 2024", "Tables - 2025", "Kitchen - 2026"],

    priorRoles: ["Music", "Tables", "Kitchen"],

    geographicScope: "BROADER_COMMUNITY",

    commitments: [

      {

        retreatId: 224,

        retreatName: "St. Mark Fall 2027",

        weekend: "October 8–10, 2027",

        conflict: false,

      },

    ],

  },

];



function buildCandidates(): TeamCandidate[] {

  return RAW_CANDIDATES.map((raw) => {

    const firstTimeTeamCandidate = raw.teamHistory.length === 0;

    const priority = computePriority({

      geographicScope: raw.geographicScope,

      firstTimeTeamCandidate,

      wasMostRecentHostParishRetreat:

        raw.attendedRetreat.wasMostRecentHostParishRetreat,

    });

    return {

      coupleId: raw.coupleId,

      displayName: raw.displayName,

      parishName: raw.parishName,

      language: raw.language,

      priority,

      priorityLabel: PRIORITY_LABELS[priority],

      firstTimeTeamCandidate,

      geographicScope: raw.geographicScope,

      status: "AVAILABLE" as CandidateStatus,

      lastRetreatAttended: raw.attendedRetreat,

      teamsServed: raw.teamHistory.length,

      priorRoles: raw.priorRoles,

      commitments: raw.commitments,

    };

  }).sort(

    (a, b) =>

      a.priority - b.priority ||

      RAW_CANDIDATES.findIndex((r) => r.coupleId === a.coupleId) -

        RAW_CANDIDATES.findIndex((r) => r.coupleId === b.coupleId),

  );

}



export function computeSummaryFromCandidates(

  candidates: TeamCandidate[],

): TeamFormationSummary {

  const inConsiderationList = candidates.filter(

    (c) => c.status === "IN_CONSIDERATION",

  );

  const inConsideration = inConsiderationList.length;

  const approvedProspects = candidates.filter(

    (c) => c.status === "APPROVED_PROSPECT",

  ).length;

  const firstTime = inConsiderationList.filter(

    (c) => c.firstTimeTeamCandidate,

  ).length;

  const experienced = inConsideration - firstTime;

  const firstTimePercentage = inConsideration

    ? Math.round((firstTime / inConsideration) * 100)

    : 0;



  return {

    inConsideration,

    approvedProspects,

    firstTime,

    firstTimePercentage,

    experienced,

    hostParish: inConsiderationList.filter(

      (c) => c.geographicScope === "HOST_PARISH",

    ).length,

    deanery: inConsiderationList.filter((c) => c.geographicScope === "DEANERY")

      .length,

    broaderCommunity: inConsiderationList.filter(

      (c) => c.geographicScope === "BROADER_COMMUNITY",

    ).length,

  };

}



export const TEAM_SIZE_GUIDANCE_TEXT =

  "Begin with eligible couples from prior LOVESTRONG Retreats. Team-size guidance is approximately 25 minimum and generally 32–35 maximum; neither is a hard blocker here.";



export const DEANERY_UNAVAILABLE_TEXT =

  "Deanery relationships are not available in current reference data. Eligible couples remain visible through host-parish and broader-community ordering.";



export function statusLabel(status: CandidateStatus): string {

  const map: Record<CandidateStatus, string> = {

    AVAILABLE: "Available Candidate",

    IN_CONSIDERATION: "In Consideration",

    SUBMITTED_FOR_REVIEW: "Submitted for Review",

    APPROVED_PROSPECT: "Approved Prospect",

    CONCERN: "Concern / Change Requested",

  };

  return map[status];

}



export function buildLeadershipAssignments(input: {

  leadName?: string;

  coLeadName?: string;

  mentorName?: string;

  retreatLiaisonName?: string;

}): TeamLeadershipAssignment[] {

  const liaison =

    input.retreatLiaisonName || "Jesse & Marta Yanez";



  return [

    {

      role: "LEAD_COUPLE",

      label: "Lead Couple",

      principalType: "COUPLE",

      principalId: null,

      displayName: input.leadName || "Luis & Ana Martinez",

      editable: false,

    },

    {

      role: "CO_LEAD_COUPLE",

      label: "Co-Lead Couple",

      principalType: "COUPLE",

      principalId: null,

      displayName: input.coLeadName || "Miguel & Rosa Santos",

      editable: false,

    },

    {

      role: "MENTOR_COUPLE",

      label: "Mentor Couple",

      principalType: "COUPLE",

      principalId: null,

      displayName: input.mentorName || "William & Sharon Lowman",

      editable: false,

    },

    {

      role: "SPIRITUAL_MENTOR_COUPLE",

      label: "Spiritual Mentor Couple",

      principalType: "COUPLE",

      principalId: null,

      displayName: null,

      editable: true,

    },

    {

      role: "SPIRITUAL_DIRECTOR",

      label: "Spiritual Director (Priest/Deacon)",

      principalType: "CLERGY",

      principalId: "clergy-velazquez",

      displayName: "Fr. Carlos Velazquez",

      editable: true,

    },

    {

      role: "RETREAT_LIAISON",

      label: "Retreat Liaison",

      principalType: "COUPLE",

      principalId: null,

      displayName: liaison,

      editable: false,

    },

  ];

}



export function buildMockWorkspace(input: {

  leadName?: string;

  coLeadName?: string;

  mentorName?: string;

  retreatLiaisonName?: string;

  useExecutiveCommittee?: boolean;

}): TeamFormationWorkspace {

  const candidates = buildCandidates();

  const liaison = input.retreatLiaisonName || "Jesse & Marta Yanez";

  const useExecutive = input.useExecutiveCommittee ?? false;



  return {

    summary: computeSummaryFromCandidates(candidates),

    candidates,

    leadership: {

      assignments: buildLeadershipAssignments({

        ...input,

        retreatLiaisonName: liaison,

      }),

      spiritualMentorOptions: MOCK_SPIRITUAL_MENTOR_OPTIONS,

      spiritualDirectorOptions: MOCK_SPIRITUAL_DIRECTOR_OPTIONS,

    },

    authority: useExecutive

      ? {

          type: "EXECUTIVE_COMMITTEE",

          reason:

            "No active Steering Committee is recorded for this parish.",

          recipients: [

            {

              role: "Executive Committee Reviewer",

              displayName: "Executive Committee Review Desk",

            },

            {

              role: "Retreat Lead Couple",

              displayName: input.leadName || "Luis & Ana Martinez",

            },

            {

              role: "Retreat Liaison",

              displayName: liaison,

            },

          ],

        }

      : {

          type: "PARISH_STEERING_COMMITTEE",

          recipients: [

            {

              role: "SC Head Couple",

              displayName: "Ruben & Leticia Castillo",

              email: "sc-head@example.test",

            },

            {

              role: "SC Co-Head Couple",

              displayName: "Hector & Monica Salinas",

            },

            {

              role: "Retreat Lead Couple",

              displayName: input.leadName || "Luis & Ana Martinez",

            },

            {

              role: "Retreat Liaison",

              displayName: liaison,

            },

          ],

        },

    retreatLiaison: liaison,

    deaneryDataAvailable: false,

    reviews: [],

    totalCandidates: candidates.length,

    pageSize: 25,

  };

}



export const MOCK_CANDIDATES = buildCandidates();


